import { atom } from "jotai";
import moment from "moment";

export const CREDIT_INVOICE = {
  name: "Invoice",
  tableCols: [
    { id: 1, label: "Invoice No" },
    { id: 8, label: "Status" },
    { id: 9, label: "Type" },
    { id: 2, label: "Customer" },
    { id: 10, label: "Diagnosis" },
    { id: 11, label: "Treatment" },
    {
      id: 3,
      label: "Due Date",
    },
    {
      id: 4,
      label: "Vist Date",
    },
    {
      id: 5,
      label: "Total",
    },
    {
      id: 6,
      label: "Recieved",
    },
    {
      id: 7,
      label: "Pending",
    },
  ],
};

export const INSTITUTION_INVOICE = {
  name: "Invoice",
  tableCols: [
    { id: 1, label: "Slip No" },
    // { id: 8, label: "Status" },
    // { id: 9, label: "Type" },
    { id: 2, label: "Patient Name" },
    { id: 3, label: "Diagnosis" },
    { id: 4, label: "Treatment" },
    // {
    //   id: 3,
    //   label: "Due Date",
    // },
    {
      id: 5,
      label: "Vist Date",
    },
    {
      id: 6,
      label: "Consultancy Bill",
    },
    {
      id: 7,
      label: "Medicine Bill",
    },
    {
      id: 8,
      label: "Total",
    },
  ],
};

export const INVOICE_MENU_OPTIONS = [
  { id: 1, label: "General Info", eleId: "gen_info" },
  { id: 2, label: "Lines", eleId: "lines" },
  { id: 3, label: "Totals", eleId: "total" },
  { id: 4, label: "CuM", eleId: "cum" },
  { id: 5, label: "Payments", eleId: "payment" },
  { id: 6, label: "History", eleId: "history" },
];

export const TYPE = [
  { key: 1, value: "Qty", text: "Qty" },
  { key: 2, value: "Amt", text: "Amt" },
];

export const UOMOPTIONS = [
  { key: 1, value: "Nos", text: "Nos" },
  { key: 2, value: "Days", text: "Days" },
  { key: 3, value: "No", text: "No" },
];

export const initialState = {
  invoice_no: "",
  invoice_total: 0,
  slot_id: null,
  opd: { id: null, opd_number: "", date: moment().format("DD MMMM YYYY") },
  invoice_date: "",
  status: "draft",
  clinic_id: null,
  admission_details: {
    admission_date: "",
    admission_time: "",
    discharge_date: "",
    discharge_time: "",
    IPD_No: "",
    ipd_id: null,
    injury_no: "",
    diagnosis: "",
    treatment: "",
  },
  discount: 0,
  discount_type: "percentage",
  invoice_lines: [
    {
      discount: "0",
      discount_type: "percentage",
      price: "0",
      type: "Amt",
      description: "",
      quantity: 1,
      sub_lines: [],
      uom: "",
      total: 0,
      line_service: null,
      line_package: null,
    },
  ],
  institution_customer: {
    id: null,
    institution_name: "",
    contact_person_name: "",
    contact_number: "",
    email_address: "",
    billing_address: {
      building_name: "",
      street_address: "",
      city: "",
      pincode: "",
    },
    communication_address: {
      building_name: "",
      street_address: "",
      city: "",
      pincode: "",
    },
    payment_terms: {
      id: null,
      due_days: null,
    },
  },
  patient_details: {
    id: null,
    full_name: "",
    phone: "",
  },
  billing_credit_payments: [
    {
      status: "Paid",
      received_payment: 0,
      transaction_date: "",
      transaction_details: "",
      payment_mode: { id: 2, type: "By cash" },
    },
  ],
};

export const INVOICE_SETUP_OPTIONS = [
  { id: 1, label: "Invoice", query: "invoice" },
  { id: 2, label: "Payment Voucher", query: "paymentvoucher" },
];

export const AVAILBILITY_SETUP_OPTIONS = [
  { id: 1, label: "Availbility", query: "availability" },
  { id: 2, label: "Block Slot", query: "blockslot" },
];

export const INVOICE_TYPE = [
  { key: 1, value: "IPD", text: "IPD" },
  { key: 2, value: "OPD", text: "OPD" },
  { key: 3, value: "PHARMACY", text: "PHARMACY" },
];

export const PAYMENT_TYPE = [
  { key: 1, value: "BY UPI", text: "UPI" },
  { key: 2, value: "BY CASH", text: "CASH" },
  { key: 3, value: "BY CHEQUE", text: "CHEQUE" },
];

export const INSTITUTION = [
  { key: 1, value: "true", text: "Institution" },
  { key: 2, value: "false", text: "Non-institution" },
];

export const INVOICE_STATUS = [
  { key: 1, value: "draft", text: "draft" },
  { key: 2, value: "published", text: "published" },
];

export const medicineStockAtom = atom([]);

export const tempIPDPatientDetailsAtom = atom({});
